import { Formik, Form } from 'formik';
import withStyles from '@material-ui/styles/withStyles';
import {
  formDataMapper,
  getFormSchema,
} from 'features/wells/schematics/helpers/utils';
import { formID } from 'features/wells/schematics/helpers/constants';
import SchematicFormFeilds from 'features/wells/schematics/components/SchematicFormFeilds';
import { EMPTY_LIST } from 'app/app.constants';

const SchematicForm = ({
  handleSubmit,
  initialValues,
  allElements,
  lengthUnit,
  widthUnit,
}) => {
  return (
    <Formik
      enableReinitialize
      onSubmit={(values) => {
        const mappedData = formDataMapper(values, lengthUnit, widthUnit);
        handleSubmit(mappedData);
      }}
      initialValues={initialValues ?? {}}
      validationSchema={getFormSchema()}
    >
      {() => (
        <Form id={formID}>
          <SchematicFormFeilds
            allElements={allElements ?? EMPTY_LIST}
            lengthUnit={lengthUnit}
            widthUnit={widthUnit}
          />
        </Form>
      )}
    </Formik>
  );
};

const styles = (theme) => ({
  fieldWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textfieldLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      background: theme.palette.background.default,
    },
  },
  field: {
    padding: theme.spacing(1),
  },
});

export default withStyles(styles)(SchematicForm);
